import { render } from "./Comics.vue?vue&type=template&id=b06178d6"
import script from "./Comics.vue?vue&type=script&lang=js"
export * from "./Comics.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Trix\\Documents\\manga-corporation-V2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__